export default __webpack_public_path__ + "static/i-MedicalCard Elite_Annual Contribution Rates-40ca64b84cb8e194c8c1a3425533a896.pdf";